// @flow
import { type Node } from 'react';

import SimpleDate from 'app/common/classes/simple-date';


type Props = {
  date: ?SimpleDate,
}

const CellDate = ({ date }: Props): Node => {
  if (!date) {
    return '—';
  }

  return date.getString('DD.MM.YYYY');
};

export default CellDate;
